import { gql } from '@apollo/client';
export const createOneCompanyActivityMutation = gql `
  mutation CreateOneCompanyActivity {
    createOneCompanyActivity(object: {}) {
      __typename
    }
  }
`;
